import { useTheme } from 'styled-components';

export const RefreshIcon: React.FC = () => {
  const theme = useTheme();
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.935 2.05625C10.6662 0.7875 8.925 0 6.99125 0C3.12375 0 0 3.1325 0 7C0 10.8675 3.12375 14 6.99125 14C10.255 14 12.9762 11.7688 13.755 8.75H11.935C11.2175 10.7887 9.275 12.25 6.99125 12.25C4.095 12.25 1.74125 9.89625 1.74125 7C1.74125 4.10375 4.095 1.75 6.99125 1.75C8.44375 1.75 9.73875 2.35375 10.6837 3.3075L7.86625 6.125H13.9912V0L11.935 2.05625Z"
        fill={theme.secondary.softBlue1}
      />
    </svg>
  );
};
